export default "__VITE_ASSET__199a48dc__"